// --- Core ---
import {map} from 'underscore';
// --- SaniQ ---
import {Chat, deserializeMessage} from "../../../models/Chat";
import * as MessagesConstants from '../constants';
import * as AppConstants from "../../app/constants";

interface ChatsState {
  collection: Array<Chat>;
  isFetching: boolean;
}

const initialState: ChatsState = {
  collection: [],
  isFetching: false
};

export function chats(state = initialState, action): ChatsState {
  switch (action.type) {
    case MessagesConstants.FETCH_CHATS_STARTED:
      return {...state, isFetching: true};
    case MessagesConstants.FETCH_CHATS_COMPLETED: {
      return {...state, collection: action.chats, isFetching: false};
    }

    case MessagesConstants.READ_MESSAGE_COMPLETED: {
      const newCollection = map(state.collection, (chat) => {
        if (chat.patient.id.toString() === action.message.authorId.toString()) {
          const updatedChat = {...chat};
          updatedChat.unreadCount += action.message.readAt ? -1 : 1;
          return updatedChat;
        }

        return chat;
      });

      return {...state, collection: newCollection};
    }

    case MessagesConstants.SEND_MESSAGE_COMPLETED: {
      const patientId = action.message.receipientId;

      const newCollection = map(state.collection, (chat) => {
        if (chat.patient.id.toString() === patientId.toString()) {
          return {
            ...chat,
            messages: [action.message]
          };
        }

        return chat;
      });

      return {...state, collection: newCollection};
    }

    case AppConstants.RECEIVE_MESSAGE: {
      if (action.message.data === undefined) return state;
      const message = deserializeMessage(action.message.data);
      //FIXME(Keune): A system message does not have the patientId as authorId
      const patientId = message.authorId;

      const newCollection = map(state.collection, (chat) => {
        if (chat.patient.id.toString() === patientId.toString()) {
          const updatedChat = {...chat, messages: [message]};
          updatedChat.unreadCount += 1;
          return updatedChat;
        } else {
          return chat;
        }
      });

      return {...state, collection: newCollection};
    }
    default:
      return state;
  }
}
